import {request} from './request.js';
import Cookie from './cookie.js';

export const isAndroid = (/android/gi).test(navigator.appVersion);
export const isIphone = (/iphone/gi).test(navigator.appVersion);
export const thirdParty = getThirdParty();
// isWechat
export const isWechat = /micromessenger/.test(navigator.userAgent.toLowerCase()) ? true : false;
// 图片加载失败
export function errorImg(img) {
    img.src = "";
    img.onerror = null;    
}

// 获取微信分享token
export function getWxtoken() {
    if (isWechat) {
        let config = {
            url: '/jsapi',
        }
        return request(config);
    }
}

export function clearCookie(item) {
    Cookie.set(item, '', {
        expires: 0,
        path: '/'
    });
}

// 同步获取环境参数
export function getThirdParty() {
    let thirdParty = '';
    if(/micromessenger/.test(navigator.userAgent.toLowerCase())) {
        thirdParty = 'wechat';
    } else {
        
    }
    return thirdParty;
}


/**
 * [px2px 750pxUE图下对应的px值转换为实际设备下展示的px值]
 * @param  {[number]} px    [750px下对应的px值]
 * @param  {[number]} base = 75            [默认基于750px进行转换]
 * @return {[number]}       [实际展示的px值]
 */
export function px2px(px, base = 75) {
    return fxtflex.rem2px(fxtflex.px2rem(px, base));
};

/**
 * [getRandom 获取【0，length-1)]之间的整数随机数
 * @param  {[number]} length: 2             [随机数个数]
 * @return {[number]}         [整数随机数，默认返回0或1]
 */
export function getRandom(length) {
    return Math.floor(Math.random() * length);
};
/**
 * [valideName 验证姓名长度]
 * @param  {[string]} val    [name 字串]
 * @param  {[number]} length [限制长度]
 * @return {[boolean]}        [Boolean]
 */
export function valideName(val, length) {
    if (val) {
        if (val.length > length) {
            return false;
        } else {
            return true;
        }
    } else {
        return false;
    }
}
/**
 * [validePhone 常规手机号验证]
 * @param  {[string]} val [待验证手机号]
 * @return {[boolean]}     [返回true || false]
 */
export function validePhone(val) {
    let reg = /(^0{0,1}1[3|4|5|6|7|8|9][0-9]{9}$)/;
    return reg.test(val)
}
/**
 * [valideMail 常规邮箱验证]
 * @param  {[string]} val [待验证手机号]
 * @return {[boolean]}     [返回true || false]
 */
export function valideMail(val) {
    let reg = /^([0-9A-Za-z\-_\.]+)@([0-9a-z]+\.[a-z]{2,3}(\.[a-z]{2})?)$/g;
    return reg.test(val);
}
/**
 * [cutHeadImg 头像阿里云方图裁剪]
 * @param  {[string]} url [用户头像]
 * @return {[string]}     [加入裁剪参数的url]
 */
export function cutHeadImg(obj) {
    obj.width = obj.width ? obj.width : 100;
    obj.height = obj.height ? obj.height : 100;
    if (obj.url) {
        if (obj.url.indexOf('?') >= 0) {
            // & 拼接
            if (obj.url.indexOf('x-oss-process=image/resize,m_fill' >= 0)) {
                return obj.url;
            }
            return `${obj.url}&x-oss-process=image/resize,m_fill,h_${obj.height},w_${obj.width}`;
        } else {
            // ? 拼接
            return `${obj.url}?x-oss-process=image/resize,m_fill,h_${obj.height},w_${obj.width}`;
        }
    }
    return '';
}
// dateFilter for js stamp
export function dateFilter(value, fmt) {
    if (value) {
        let date = new Date(value);
        var o = {
            "M+": date.getMonth() + 1,                 //月份
            "d+": date.getDate(),                    //日
            "h+": date.getHours(),                   //小时
            "m+": date.getMinutes(),                 //分
            "s+": date.getSeconds(),                 //秒
            "q+": Math.floor((date.getMonth() + 3) / 3), //季度
            "S": date.getMilliseconds()             //毫秒
        };
        if (/(y+)/.test(fmt))
            fmt = fmt.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
        for (var k in o)
            if (new RegExp("(" + k + ")").test(fmt))
                fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
        return fmt;
    } else {
        return '   -'
    }
}

/**
 * [时间戳转换为时间]
 * @param  {[String]} timeStamp [以毫秒为单位]
 * @return {[Array]}           [年，月，日，时，分，秒]
 */
export function toDate (timeStamp) {
    var currentDate = new Date(Number(timeStamp)); 
    var currentTime = currentDate.getTime();
    var currentHour = currentDate.getHours();
    var currentMinute = currentDate.getMinutes();
    var currentSeconds = currentDate.getSeconds();
    var currentYear = currentDate.getFullYear();
    var currentMonth = currentDate.getMonth();
    var currentDay = currentDate.getDate();
    return [currentYear, currentMonth + 1, currentDay, currentHour, currentMinute, currentSeconds];
}

/**
 * [判断是否为数组]
 * @param  {[Object]} obj  任意对象 数组、字符串，对象等
 * @return {[Boolean]}     
 */
export function isArray (obj) {
    return Object.prototype.toString.call(obj)=='[object Array]';
}


// WEBPACK FOOTER //
// ./src/common/util/global.js